import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/esm/Container';
import ins1 from "../images/instructions1.jpg"
import faqLP from "../images/faqLP.PNG"

export default function Configuration() {

  const toggleCollapsible = (e) => {
    if (e.currentTarget.parentNode.classList.contains("opened")) {
      e.currentTarget.parentNode.classList.remove('opened')
    } else {
      Array.from(document.querySelectorAll('.collapsible')).forEach((el) => el.classList.remove('opened'));
      e.currentTarget.parentNode.classList.add("opened");
    }
  }

  return (
    <Container>
      <h1 id="config_header">Instructions</h1>

      <div>
        <p>SUPER IMPORTANT</p>
        <p><b>YOU CAN ONLY RUN 1 ELEMENT DATA APP, ON 1 PC, PER IP ADDRESS</b></p>
        <p>Your Awair device DO NOT NEED to be on the same network but you can have ONLY 1 APP running on your network for 1 AWAIR at a time </p>
        <p>If you do not follow this rule, you WILL be IP locked and you WON'T get rewards for all the devices with the same IP address</p>
        <p>You have been warned</p>
      </div>
      <br></br>
      <div>
        <ol>
          <li><p>Make sure you Awair Element is ON and connected to the internet. Make sure you can see the air quality data in your Awair Home app on your phone before proceeding.</p></li>
          <li><p>Set your device location (IMPORTANT). How to do it is described in the FAQ below.</p></li>
          <li><p>Get your Awair Cloud API Access token and login with your Awair account username and password, If you have multiple devices under the same account, they will have the same token so you only need to get it once.</p><p>Get your token here : <a href="https://developer.getawair.com/console/access-token" target="_blank">https://developer.getawair.com/console/access-token</a></p></li>
          <li><p>Download the appropriate version of the app based on your system</p>
            <p>If you are on Windows, open the installer and install the app as usual.</p>
            <p>If you are on macOS, extract the zip file and copy the app to your Applications folder and run it from there. If you get a message saying the app can't be opened, just right click on the app and choose Open. You'll get the dialog again but with a button to open the app correctly.</p>
            <p>If you are on Linux, extract the archive, place the file in the desired directory and run it, make sure you have Qt Network installed as dependencies</p></li>
          <li><p>After installation, the app will be opened in the background. You can see it in your task bar at the bottom right on Windows or your top bar on macOS. Click on it and you should see the app window come up on screen.</p></li>
          <li><p>You will see a field named "Awair access token". Copy and paste your token from step #3 in the field and hit save. You should get a list with all your Awair devices. NOTE: IF YOU DO NOT SEE THE LIST OF DEVICES, STOP THERE AND MAKE SURE YOU COPY AND PASTED THE CORRECT TOKEN OTHERWISE IT WILL NOT WORK </p></li>
          <li><p>Select your device and enter a password for your account. It will be used to login to your account on the Element Data website so remember it. If you wish to change the password, you will be able to do it in the app later. You should now see the air quality data update in the app. NOTE: The data updates only every 15 minutes. It's normal that you might think it is not working, but it is</p></li>
          <li><p>At this point, you should see a "Logged in" message in the bottom left corner of the app. If not, you missed something. Close the app and try again. To close the app, you NEED to right click the little app icon and click on QUIT, then open the app again. Clicking on the X in the corner to close the window DOES NOT close the app. You can also press CMD+Q on macOS to quit the app completely</p></li>
          <li><p>The app should now send the first stream within a few seconds. You should see a Successful stream message and your balance increase.</p></li>
          <li><p>Congrats! You are all set up! Leave the app as-is. Do not restart again and again for no reason, it won't help. </p></li>
        </ol>
      </div>


      <div className="bottom-line"></div>

      <br/>
      <h2 id="config_header">FAQ</h2>
      <div className="bottom-line"></div>

      <div className="collapsible">
        <h3 className="collapsible-trigger" onClick={toggleCollapsible}>Troubleshooting</h3>
        <div className="collapsible-content">
          <p><b>I get a message saying "Sending data..." at the bottom of the app and it's stuck there.</b></p>
          <p>You did not set your location correctly. Do it again. Check the info on this page how to set it up and restart the Element Data app using the QUIT button and open it again and WAIT at least 15 mins to 1 hour.</p>
          <p><b>I get a message saying "Waiting for first stream. Do not restart the app at this point." at the bottom of the app.</b></p>
          <p>If you are in the first hour after setup or you just restarted the app, It's common. Just wait. If you keep restarting the app at this point before an hour passed, you have to wait another FULL HOUR before anything will happen.</p>
          <p><b>I get a message saying "Last successful stream: (date)*" but my balance doesn't increase.</b></p>
          <p>You have multiple apps opened like or you have multiple apps running on the same IP address and you are now IP locked. You've been warned in the setup instructions in big bold letters. <b>YOU CAN ONLY RUN 1 ELEMENT DATA APP, ON 1 PC, PER IP ADDRESS</b> .</p>
          <p><b>My IP got blocked because I did not follow the rule and my balance doesn't increase anymore!!!</b></p>
          <p>1) Make sure you don't have multiple apps running on the same PC.</p>
          <p>2) Close the other apps on the same network and make sure you only have one running.</p>
          <p>3) The system will automatically unblock you after a delay of about 6 hours of penalty.</p>
          <p><b>I get a message saying "Invalid password!" </b></p>
          <p>Go to the account page (logout if you're logged in) and reset your password.</p>
        </div>
      </div>

      <div className="collapsibles-container">
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>How do I set my Awair Element device location?</h3>
          <div className="collapsible-content">
            <p><b>This is required.</b> So it's a good thing to set it up.</p>
            <div>
              <ol>
                <li><p>Go to your "Homes"</p></li>
                <li><p>Select the home you want to set the location and hit the gear icon</p></li>
                <li><p>Tap on the Find New Location space</p></li>
                <li><p>After the location is found, don't forget to hit SAVE</p></li>
              </ol>
            </div>
            <p><img src={ins1} alt=""/></p>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>How do I update my app to the newest version?</h3>
          <div className="collapsible-content">
            <p>1) Go to the Downloads page and download the latest version</p>
            <p>2) Install the new version using the installer you just downloaded.</p>
            <p>3) The setup will ask to close the currently working app, if it's opened. Agree and proceed.</p>
            <p>4) Done!</p>
            <p>5) (optional) If you are coming from the Local API version, you'll need to enter your Cloud API token at this point. See setup instructions above</p>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>What do I have to do after all this?</h3>
          <div className="collapsible-content">
            <p>Backup your settings file.</p>
            <p>DO NOT uninstall the app for no reason. It won't help if you are having problems.</p>
            <p>Never run 2 apps on the same network. You WILL be IP LOCKED and both apps won't receive rewards</p>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>What happens if I use the same device in the same location ? Will I be banned ?</h3>
          <div className="collapsible-content">
            <p>You will not be banned, but the balance on each device that is running in that location wouldn't increase, until you resolve that situation, by either shutting down one of those devices or moving it to another location</p>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>Is there a configuration file ?</h3>
          <div className="collapsible-content">
            <p>Yes, Settings.ini file is located in AppData folder (press Win+R and type %appdata%) then go into ElementData folder</p>
            <p>For Linux and Mac it's in the .config directory</p>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>How do I add liquidity and get Premium plan ?</h3>
          <div className="collapsible-content">
            <p>You can do that by visiting this link : </p>
            <a href="https://app.tinyman.org/#/pool/ED57RDPEG53HHJKAHQGFBF74GUZ5JHH464424OZ4NSOJVV5VAL5YLZXQ5U/add-liquidity" target="_blank">Tinyman LP</a>
            <p>Then for the IAQ token you enter for example 240 and the rest will auto-populate, you can click on "Show more" to see how much LP tokens that would be, like in this screenshot example, once you enter the values which produce 5 or more LP tokens, you click on ADD and that's it</p>
            <img src={faqLP} alt="faq2"/>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>When are rewards distributed?</h3>
          <div className="collapsible-content">
            <p>Every hour you should see the balance in your Element Data app go up according to your plan.</p>
            <p>If after a few hours it still shows 0, you did something wrong somewhere. The balance in the app is updated more frequently than on the website, so you might want to check it there.</p>
            <p>Payouts to wallets are made daily and start at around 9:15AM EST (GMT -5) , 2:15PM CET.</p>
            <p>You need to have IAQ token opted-in to your wallet in order to get your payout. If you did not do it, you will not receive it.</p>
            <p>You get 1 payout per device so it is normal that if you have more than 1 device, they might not arrive at the same time.</p>
            <p>If you did not receive your balance to your wallet, it might be because you did not set your wallet in your account OR you missed the threshold of the day for doing so. You'll get them the next day.</p>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>If I have multiple devices and I want to get the Starter or Premium plan, do I need to get one for each device?</h3>
          <div className="collapsible-content">
            <p>Yes, the plan is tied to the device and not the wallet. This means you would need to purchase the Starter plan for each device or have at least 5 LPs token for each device to get Premium on all of them.</p>
            <p>Premium:</p>
            <p>2 devices - 10 LPs</p>
            <p>3 devices - 15 LPs</p>
            <p>...</p>
            <p>You can use the same wallet for all your devices if you wish to do so.</p>
            <p>The first device to send a stream when you have the LPs in your wallet will get the Premium status. So if you want to really chose which one gets the Premium, maybe a good idea to use different wallets.</p>
          </div>
        </div>
        <div className="collapsible">
          <h3 className="collapsible-trigger" onClick={toggleCollapsible}>I ran 2+ apps on the same network, they are sending stream but my balance doesn't go up!!</h3>
          <div className="collapsible-content">
            <p>The rule is clear, 1 app per 1 public IP address. This means you got locked by the system.</p>
            <p>The solution is simple, turn off the additional apps to only have 1 running on a single public IP address or move your app to another IP address.</p>
            <p>Wait a few hours and you'll get unlocked automatically.</p>
            <p>If you do not do this to get unlocked, there is nothing more that can't be done.</p>
          </div>
        </div>


      </div>

      <br/>
      <br/>
      <br/>
    </Container>
  );
}
